export const errorsCodes = Object.freeze({
  SERVER_ERROR: 'SERVER_ERROR',
  TOO_LARGE_REQUEST: 'TOO_LARGE_REQUEST',
  SESSION_REQUIRED: 'SESSION_REQUIRED',
  USER_BLOCKED: 'USER_BLOCKED',
  TOO_MANY_CODE_REQUESTS: 'TOO_MANY_CODE_REQUESTS',
  CAPTCHA_VERIFICATION_FAILED: 'CAPTCHA_VERIFICATION_FAILED',
  NOT_FOUND: 'NOT_FOUND'
});
